<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<div class="main-container" > 
    <!-- ============================================================== -->
    <!-- Topbar - style you can find in header.scss -->
    <!-- ============================================================== -->
    <mat-toolbar class="topbar telative" style="background-color: #ffffff; ">
        <!-- ============================================================== -->
        <!-- Logo - style you can find in header.scss -->
        <!-- ============================================================== -->
        <div class="navbar-header">
            <a class="navbar-brand" href="home" style="display: block; align-content: center;">
                <!-- Logo icon -->
                <b>
                    <!--You can put here icon as well // <i class="wi wi-sunset"></i> //-->
                    <!-- Light Logo icon -->
                    <img [class.hide-on-small]="shouldHideImage()" src="assets/images/junji-logo.jpg" height="50px" alt="home" class="light-logo">
                </b>
                <!--End Logo icon -->
                <!-- Logo text -->
                <span class="text-logo-icon" fxShow="false" fxShow.gt-xs>                 
                </span> </a>
        </div>
        <!-- ============================================================== -->
        <!-- sidebar toggle -->
        <!-- ============================================================== -->

        <button mat-icon-button *ngIf="!mobileQuery.matches" (click)="snav.toggle() " value="sidebarclosed">
            <mat-icon style="color: #0661b3;">menu</mat-icon>
        </button>
        <button mat-icon-button *ngIf="mobileQuery.matches" (click)="toggleSidenav()" value="sidebarclosed">
            <mat-icon style="color: #0661b3;">menu</mat-icon>
        </button>


        <div style="flex-grow: 1; color: #0661b3; display: flex; align-items: center; justify-content: center;">
            <img *ngIf="logoSistemaTexto == ''" [class.hide-on-small]="shouldHideImage()" src="{{logoSistema}}" class="light-logo" alt="homepage" style="flex: 0;">
            <mat-label *ngIf="logoSistemaTexto != ''" [class.hide-on-small]="shouldHideTitle()" style="flex: 0; font-size: 1vw;">{{logoSistemaTexto}}</mat-label>
            <mat-label *ngIf="ambiente != 'PROD'" [class.hide-on-small]="shouldHideTitle()" style="color: red; flex: 0; font-size: 1vw;">AMBIENTE: {{ambiente}}</mat-label>
        </div>
       
        <!-- ============================================================== -->
        <!-- app header component - style you can find in header.scss / header.component.ts-->
        <!-- ============================================================== -->
        <app-header class="d-flex align-items-center ml-auto"></app-header>
    </mat-toolbar>
    <!-- ============================================================== -->
    <!-- End Topbar - style you can find in pages.scss -->
    <!-- ============================================================== -->
    <mat-sidenav-container class="example-sidenav-container" [style.marginTop.px]="mobileQuery.matches ? 0 : 0">
        <!-- ============================================================== -->
        <!-- Sidebar - style you can find in sidebar.scss -->
        <!-- ============================================================== -->
        <mat-sidenav #snav id="snav" class="dark-sidebar pl-xs" mode="side" 
        [style.width.px]="sidenavWidth" [mode]="mobileQuery.matches ? 'side' : 'over'" fixedTopGap="0" 
        [opened]="mobileQuery.matches" [disableClose]="mobileQuery.matches" >
                <app-sidebar></app-sidebar>  
        </mat-sidenav>
        
        <!-- ============================================================== -->
        <!-- Sidebar - style you can find in sidebar.scss -->
        <!-- ============================================================== -->
        
        <!-- ============================================================== -->
        <!-- Page container - style you can find in pages.scss -->
        <!-- ============================================================== -->
        <mat-sidenav-content class="page-wrapper" [style.margin-left.px]="mobileQuery.matches ? sidenavWidth : 0" >                 
                <div class="page-content">                   
                        <router-outlet><!-- <app-spinner></app-spinner> --></router-outlet>                    
                </div>
        </mat-sidenav-content>
        <!-- ============================================================== -->
        <!-- Page container - style you can find in pages.scss -->
        <!-- ============================================================== -->
    </mat-sidenav-container>  
</div>